import { jwtDecode } from 'jwt-decode';

/**
 * Permissões efetivas da sessão considerando acesso externo.
 * Não-admins fora da rede interna: poderes de nível 1 + visualizar infrações,
 * salvo se externalFullAccess (acesso normal cedido).
 */
export function getSessionPermissions(tokenOrDecoded) {
  let decoded = tokenOrDecoded;

  if (typeof tokenOrDecoded === 'string') {
    try {
      decoded = jwtDecode(tokenOrDecoded);
    } catch {
      return {
        role: 1,
        actualRole: 1,
        isInternal: true,
        externallyRestricted: false,
        externalFullAccess: false,
        effectiveRole: 1,
        canViewInfractions: false,
        canAccessBatches: false,
        isAdmin: false,
      };
    }
  }

  if (!decoded) {
    return {
      role: 1,
      actualRole: 1,
      isInternal: true,
      externallyRestricted: false,
      externalFullAccess: false,
      effectiveRole: 1,
      canViewInfractions: false,
      canAccessBatches: false,
      isAdmin: false,
    };
  }

  const actualRole = Number(decoded.role) || 1;
  // Tokens antigos sem isInternal: assume interno para não rebaixar poderes indevidamente
  const isInternal = decoded.isInternal !== false;
  const externalFullAccess = decoded.externalFullAccess === true;
  const isAdmin = actualRole >= 5;
  const externallyRestricted = !isAdmin && isInternal === false && !externalFullAccess;
  const effectiveRole = externallyRestricted ? 1 : actualRole;

  return {
    role: effectiveRole,
    actualRole,
    isInternal,
    externallyRestricted,
    externalFullAccess,
    effectiveRole,
    canViewInfractions: isAdmin || externallyRestricted || effectiveRole >= 2,
    canAccessBatches: effectiveRole >= 2,
    isAdmin,
  };
}

export const isTokenValid = (token) => {
  if (!token) return false;

  try {
    const decodedToken = jwtDecode(token);
    const currentTime = Date.now() / 1000;

    return decodedToken.exp > currentTime;
  } catch (error) {
    return false;
  }
};
